import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomSelectProps } from './CustomSelect.types';
import { SelectA11y } from '@base-app';
import { StyledLabel, StyledTarget } from './CustomSelect.styles';
import { Variants } from '@/common/types';

const CustomSelect: FC<CustomSelectProps> = ({ field, index, isEditing }) => {
  const methods = useFormContext();
  const options = field.options ?? [];
  const id = `custom-select-${field.name.split(' ').join('-').toLocaleLowerCase()}`;
  const isSensitive = field.isSensitive ?? false;

  const { control } = methods;

  return (
    <>
      <StyledLabel data-testid={`custom-select-label`}>{field.name}</StyledLabel>
      {!isEditing && (
        <StyledTarget data-testid={id}>
          {field.options?.find((option) => option.id === field.target)?.label}
        </StyledTarget>
      )}
      {isEditing && (
        <Controller
          control={control}
          defaultValue={field.target}
          name={`dynamicInputs.${index}.target`}
          render={({ field, fieldState: { error } }) => {
            return (
              <SelectA11y
                {...field}
                defaultValue={field.value || ''}
                error={!(error?.message == null)}
                errorDescription={error?.message as string}
                fullWidth
                id={field.name}
                items={options}
                label={''}
                listWidth="100%"
                name={field.name}
                testId={id}
                value={field.value}
                variant={Variants.PRIMARY}
                isSensitive={isSensitive}
              />
            );
          }}
        />
      )}
    </>
  );
};

export default CustomSelect;
